module.exports = __webpack_public_path__ + "img/Frame 904.5ef7ae67.svg";